
<div class="fdm-sidebar-toolbar fdm-buttons clearfix">

	<!-- prototyping new shape editor, don't delete ... <fa-icon icon="plus" class="fdm-linked" (click)="toggleShapeEditor()" [class.fdm-selected-main]="editingShape"></fa-icon> -->

	<!-- Add annotation shape -->
	<button id="add-shape" *ngFor="let item of gui.tools"
		class="fdm-linked pointer fdm-tools-button float-left fdm-tools-button-accent"
		[class.fdm-selected]="selectedTool.id == item.id"
		[matTooltip]="'MAP.' + item.id | translate"
		(click)="selectTool(item)">
		<fa-icon [icon]="['fal',item.icon]"></fa-icon>
	</button>

	<!-- Quick guides icon -->
	<button *ngIf="permissions?.can?.show_intro_tour?.site_settings"  
		class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
		[matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="uiManager.toggleQuickGuidePopup('map', true)">
		<fa-icon icon="question-circle"></fa-icon>
	</button>
</div>

<!-- Help description of annotation tool -->
<div class="mt-2 text-center" style="border-radius:4px;background-color:#eee;padding:10px;font-size:10px;color:#555;font-style:italic;" *ngIf="selectedTool">
	{{ 'MAP.HELP.TOOLS.'+selectedTool.id | translate }}
</div>

<div class="fdm-sidebar-tabs-body">
	<div class="fdm-sidebar-body fdm-drag-drop-zone-neutral">

		<!-- Annotation search field -->
		<div class="fdm-tb-space fdm-form-field-tight fdm-form-field-neutral">
			<mat-form-field id="annotation-search" class="w-100 fdm-search-field" appearance="fill" *ngIf="currentType !== 'photogram' && currentType !== 'terrain-compare'">
				<input matInput style="width:40%;" type="text" name="foo" [formControl]="searchCont" [placeholder]="'MAP.MODES.INSPECT' | translate"/>
				<span matSuffix *ngIf="searchCont.value?.length" (click)="searchCont.setValue('')" class="mr-1"><fa-icon icon="times"></fa-icon></span>
				<span matPrefix class="mr-1"><fa-icon icon="search"></fa-icon></span>
			</mat-form-field>
		</div>

		<!-- other -->
		<div *ngIf="mapService.isD360" class="p-1 p-sm-3">
			<mat-form-field class="full-width">
				<mat-select placeholder=" {{ 'MAP.MODES_FILTER' | translate }}" [(ngModel)]="classFilter" (selectionChange)="filterClass(classFilter)"multiple>
					<mat-option *ngFor="let cur of classTypes" [value]="cur">{{cur}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<!-- filter spinner -->
		<div  class="mt-4 w-100 text-center" *ngIf="loading">
			<mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
		</div>

		<!-- Filter by scene -->
		<mat-slide-toggle class="float-right" id="annotation-filter" color="primary" [(ngModel)]="globalScope" (change)="filterAnnotationsByScene()">
			<span style="font-size:12px;color:#888;">{{ 'TOOLBAR.FILTER_SCENE' | translate }}</span>
		</mat-slide-toggle>

		<div class="clearfix"></div>

		<!-- Annotation items -->
		<table class="fdm-sidebar-table-list"  *ngIf="!loading">
		<tr>
			<!-- Annotation name -->
			<th colspan="2" style="width:50%;">{{ 'FILE_LIST.HEADING.name' | translate }}</th>

			<!-- Annotation category -->
			<th style="width:30%;">{{ 'FILE_LIST.HEADING.categories' | translate }}</th>

			<!-- View annotation yes/no -->
			<th class="fdm-table-tools">{{ 'FILE_LIST.HEADING.view' | translate }}</th>
		</tr>

		<ng-container *ngFor="let cur of mapService.annotations; let i = index">
			<tr *ngIf="cur['annotationMode'] !== 'flyToLine'"
			class="fdm-linked" [class.fdm-sidebar-selected]="cur == selected">

				<td class="fdm-table-icon" (click)="mapService.helper.sendCameraTo(cur)">
					<fa-icon [icon]="getStandardIcon(cur)" [style.font-size]="getStandardIconStyletweak(cur)" [class]="cur.color ? 'fdm-annotation-color-' + cur.color : 'fdm-annotation-color-blue'"></fa-icon>
				</td>

				<td class="fdm-table-title" (click)="setSelected(cur,true,'inspect.html');mapService.helper.sendCameraTo(cur)">
					{{ cur.name }} <span *ngIf="cur?.shapes?.length > 1" class="fdm-count-inv">{{ cur?.shapes?.length }}</span>
				</td>

				<td class="fdm-table-metadata" (click)="setSelected(cur,true);mapService.helper.sendCameraTo(cur)">
					<span *ngIf="cur['categories']">
						<span class="fdm-tag" *ngFor="let i of cur['categories']">
							{{ i['label'] | normaliseAcl | async}}
						</span>
					</span>
					<!-- {{ cur.dateUpdated | dateAgo | async }} -->
				</td>

				<td class="fdm-table-tools">
					<fa-icon icon="trash" class="pointer danger mt-1" *ngIf="editing" (click)="deleteAnnot(cur)"></fa-icon>
					<input id="annotation-deselect" [(disabled)]="selected?.id == cur.id" *ngIf="!editing && cur['annotationMode'] && cur['annotationMode'] !== 'PIN' && cur['annotationMode'] !== 'poi'" 
						type="checkbox" class="mt-1" (change)="showHideAnnotation(cur, $event)"
					[(ngModel)]="cur['showPermanent']"/>
				</td>
			</tr>

			<!-- debug -->
			<!-- <tr><td colspan="4">
				<textarea style="width:100%;height:270px;font-size:9px;">{{ cur | json }}</textarea>
			</td></tr> -->

		</ng-container>

		</table>

		<!-- none filtered found error message -->
		<div class="mt-2 alert primary-bg-light text-center" *ngIf="!mapService?.annotations?.length && searchCont.value?.length && !loading" translate>
			MAP.MODES.NO_RES
		</div>

	</div>
</div>
